import styled from 'styled-components';

export default styled.div`
  display: block;
  position: absolute;
  top: 5%;
  left: auto;
  right: 110%;
  
  @media screen and (max-width: 991.98px) {
    display: none;
  }
`;
